import { useContext } from 'react';
import { ExternalRowSelectionContext } from 'src/common/components/ConfigurableTable/Components/Rows/ExternalRowSelection/ExternalRowSelectionContext';

export const useExternalRowSelectionApi = () => {
  return useContext(ExternalRowSelectionContext);
};
